import { type KeyValueStore } from 'core/infra/keyvalue/KeyValueStore'

import { type SuggestedPreferredLane } from '../domain/SuggestedPreferredLane'

type SuggestedPreferredLaneRepositoryDependencies = {
  suggestedPreferredLaneKeyValueStore: KeyValueStore<SuggestedPreferredLane>
}

export class SuggestedPreferredLaneRepository {
  private suggestedPreferredLaneKeyValueStore: KeyValueStore<SuggestedPreferredLane>

  constructor({
    suggestedPreferredLaneKeyValueStore,
  }: SuggestedPreferredLaneRepositoryDependencies) {
    this.suggestedPreferredLaneKeyValueStore = suggestedPreferredLaneKeyValueStore
  }

  upsert(id: string, suggestedPreferredLane: SuggestedPreferredLane): Promise<void> {
    return this.suggestedPreferredLaneKeyValueStore.set(id, suggestedPreferredLane)
  }

  getById(id: string): Promise<SuggestedPreferredLane | undefined> {
    return this.suggestedPreferredLaneKeyValueStore.get(id)
  }

  getAll(): Promise<Array<SuggestedPreferredLane>> {
    return this.suggestedPreferredLaneKeyValueStore.values()
  }

  delete(id: string): Promise<void> {
    return this.suggestedPreferredLaneKeyValueStore.remove(id)
  }
}
